import { createSlice } from "@reduxjs/toolkit";
import { getCreativesForPublish, getPublishList, getScriptPublishTag } from "./thunk";
import { dcm } from "./dcm/dcm";
import { adform } from "./adform/adform";
import { facebook } from "./facebook/facebook";

export const initialState = {
  whereToPublish: false,
  publishTypes: [],
  selectedPublishType: null,
  creativesForPublish: null,
  selectedCreativesPublish: [],
  publishedCreatives: null,
  scriptPublishTag: null,
  selectedPublishTagId: null,
  publishLoader: false,
  // DCM
  ...dcm.state,
  // Adform
  ...adform.state,
  // Facebook
  ...facebook.state,
}

const publishSlice = createSlice({
  name: "Publish",
  initialState,
  reducers: {
    setWhereToPublish(state, action) {
      state.whereToPublish = action.payload;
    },
    setPublishList(state, action) {
      state.publishTypes = action.payload;
    },
    setSelectedPublishType(state, action) {
      state.selectedPublishType = action.payload;
    },
    setCreativesForPublish(state, action) {
      state.creativesForPublish = action.payload;
    },
    setSelectedCreativesPublish(state, action) {
      state.selectedCreativesPublish = action.payload;
    },
    selectCreativeForPublish(state, action) {
      state.selectedCreativesPublish = [...state.selectedCreativesPublish, action.payload];
    },
    removeCreativeForPublish(state, action) {
      const filteredCreativesPublish = state.selectedCreativesPublish.filter(item => item._id !== action.payload._id);
      state.selectedCreativesPublish = filteredCreativesPublish;
    },
    setPublishedCreatives(state, action) {
      state.publishedCreatives = action.payload;
    },
    setScriptPublishTag(state, action) {
      state.scriptPublishTag = action.payload;
    },
    setSelectedPublishTagId(state, action) {
      state.selectedPublishTagId = action.payload;
    },
    setPublishLoader(state, action) {
      state.publishLoader = action.payload;
    },
    resetPublishState(state) {
      state.whereToPublish = false;
      state.publishTypes = [];
      state.selectedPublishType = null;
      state.creativesForPublish = null;
      state.selectedCreativesPublish = [];
      state.publishedCreatives = null;
      state.scriptPublishTag = null;
      state.selectedPublishTagId = null;
      state.publishLoader = false;
    },
    // DCM
    ...dcm.reducers,
    // Adform
    ...adform.reducers,
    // Facebook
    ...facebook.reducers,
  },
  extraReducers: builder => {
    builder.addCase(getPublishList.fulfilled, (state, action) => {
      state.publishTypes = action.payload;
    });
    builder.addCase(getCreativesForPublish.fulfilled, (state, action) => {
      state.creativesForPublish = action.payload;
    });
    builder.addCase(getScriptPublishTag.fulfilled, (state, action) => {
      state.scriptPublishTag = action.payload;
    });
    // DCM
    dcm.getExtraReducers(builder);
    // Adform
    adform.getExtraReducers(builder);
    // Facebook
    facebook.getExtraReducers(builder);
  }
});

export const {
  setWhereToPublish,
  setSelectedPublishType,
  setPublishList,
  setCreativesForPublish,
  setSelectedCreativesPublish,
  selectCreativeForPublish,
  removeCreativeForPublish,
  setPublishedCreatives,
  setSelectedPublishTagId,
  setScriptPublishTag,
  setPublishLoader,
  resetPublishState,
  // DCM
  setDcmProfileId,
  setProfileAsked,
  setDcmProfiles,
  setDcmPublishSettings,
  setDcmAdvertisers,
  setDcmAdvertiserId,
  setDcmCampaigns,
  setDcmCampaignId,
  setDcmPublishType,
  setDcmPoliteLoad,
  setDcmName,
  resetDcmState,
  // Adform
  setAdformCredentialAsked,
  setAdformCredentialCreated,
  setAdformCredentialError,
  resetAdformCredentialError,
  setAdformPublishSettings,
  setAdformAdvertisers,
  setAdformAdvertiserId,
  setAdformCampaigns,
  setAdformCampaignId,
  setAdformName,
  setAdformPublishType,
  setAdformPoliteLoad,
  resetAdformState,
  // Facebook
  setFbCatalogPublishSettings,
  setUserFacebookId,
  setIsUserAuthChecked,
  setBusinessList,
  setFbBusinessId,
  setCatalogList,
  setCatalogId,
  setIsBusinessAuthenticated,
} = publishSlice.actions;

export default publishSlice.reducer;